export default ({
  namespaced: true,
  state: {
    view: 'snackbar',
    defaultValues: {text: '', color: 'info', dialog: false, timeout: 3000},
    values: {}
  },
  getters: {
    values: state => {
      return state.values
    }
  },
  mutations: {
    change_values (state, payload) {
      let timeout = state.defaultValues['timeout']
      // caso não tenha sido incluido manualmente o timeout, coloca um timeout de acordo com a cor(tipo)
      if (!payload['timeout']) {
        if (payload['color']) {
          if (payload['color'] === 'error') {
            timeout = 10000
          } else if (payload['color'] === 'warning') {
            timeout = 10000
          } else if (payload['color'] === 'success') {
            timeout = 3000
          }
        }
      }
      state.values = JSON.parse(JSON.stringify(state.defaultValues))
      state.values['timeout'] = timeout
      Object.assign(state.values, payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/snackbar.js